import React from 'react';

function LatestRelease(props) {
    const {latestRelease} = props
    return (
        <div className='basis-full sm:basis-1/3 flex flex-col'>
            <div className="flex flex-row items-center text-violet-700 font-black text-base md:text-lg mb-4">
                آخرین ریلیز
            </div>
            <div className='flex flex-col md:flex-row items-center space-x-3 space-x-reverse'>
                <img src={latestRelease.image} className='w-[160px] h-[160px] rounded mb-1 md:mb-0' alt=""/>
                <div className="flex flex-col text-gray-800">
                    <div className='text-sm font-medium mb-2'>{latestRelease.name}</div>
                    <div className='text-xs'>{latestRelease.date}</div>
                </div>
            </div>
        </div>
    );
}

export default LatestRelease;